import { flatten, map, partition } from 'ramda';

import type { GameGroup } from '@ezugi/types';

import { sortTablesByGameId } from './sortTablesByGameId';

import type { LobbyTable } from '../types/table';

/**
 * Sort tables putting the ones available in current language first, then adding the rest.
 * Each of the 2 subsets are then sorted using the `default` rule.
 * This sorting is applied when BO config `tables_sorting_type` is `language`
 * @see sortTablesByGameId
 */
export const sortTablesByLanguage = ({ groupLiveTables, groupConfig, language }: {
  groupLiveTables: LobbyTable[];
  groupConfig: GameGroup;
  language: string;
}) => flatten(
  map(
    (tablesSortedByLanguage) => sortTablesByGameId({
      groupLiveTables: tablesSortedByLanguage,
      groupConfig,
    }),
    partition<LobbyTable>(
      (table: LobbyTable) => table.language === language,
      groupLiveTables
    )
  )
);
